import React from 'react';
import Styled from './styled';

const Counter = ({ value, max, setValue }) => {
  const increment = () =>
    setValue(value === max ? value : value + 1);
  const decrement = () => setValue(value - 1);

  return (
    <Styled.Counter>
      <Styled.Btn onClick={decrement} disabled={value === 0} type="button">
        -
      </Styled.Btn>
      <Styled.Value>{value}</Styled.Value>
      <Styled.Btn onClick={increment} disabled={value === max} type="button">
        +
      </Styled.Btn>
    </Styled.Counter>
  );
};

export default Counter;
